'use strict'

// name and value of the csrf protection token header
export const CSRF_PROTECTION_HEADER_NAME = 'X-Client-Token'
export const CSRF_PROTECTION_HEADER_VALUE = 'MDk2MzEzYWQxYTI4'

export const DEFAULT_CONTEXT_PATH = '/api'

export const FETCH_STATE_PENDING = 'pending'
export const FETCH_STATE_FULFILLED = 'fulfilled'
export const FETCH_STATE_REJECTED = 'rejected'
